var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "field is-horizontal is-small" }, [
    _vm.title
      ? _c("div", { staticClass: "field-title" }, [
          _c("small", [_vm._v(_vm._s(_vm.title))]),
        ])
      : _vm._e(),
    _vm.label
      ? _c("div", { staticClass: "field-label" }, [
          _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "field-body" }, [
      _c(
        "div",
        { staticClass: "field has-addons" },
        [
          _vm.prefixPosition === "left" && _vm.prefix
            ? _c("p", { staticClass: "control pos-left" }, [
                _c("span", { staticClass: "button is-static" }, [
                  _vm._v(_vm._s(_vm.prefix)),
                ]),
              ])
            : _vm._e(),
          _c("b-input", {
            attrs: {
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              type: _vm.inputType,
              expanded: "",
              size: "is-small",
            },
            model: {
              value: _vm.localValue,
              callback: function ($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue",
            },
          }),
          _vm.prefixPosition === "right" && _vm.prefix
            ? _c("p", { staticClass: "control pos-right" }, [
                _c("span", { staticClass: "button is-static" }, [
                  _vm._v(_vm._s(_vm.prefix)),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }